import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Cards from 'react-credit-cards';
import { DataTable } from '../common';
import { getAccountId, getUserName } from '../../localStorage';
import { cardTokenFields } from '../../constantsApp';
import { getDataCardFromURL } from '../../utils/utils';

class TopUp extends Component {
  constructor() {
    super();
    this.state = {
      cardToken: '',
      cardExpiry: '',
      last4CC: '',
    };
  }

  componentDidMount() {
    const {
      history: { location: { search } },
      handleAddCreditCardFromURL,
    } = this.props;
    let token = '';
    let expiryDate = '';
    let last4 = '';
    if (search) {
      token = getDataCardFromURL(search, cardTokenFields.token);
      expiryDate = decodeURIComponent(getDataCardFromURL(search, cardTokenFields.expiryDate));
      last4 = getDataCardFromURL(search, cardTokenFields.last4cc);
    }
    if (token && expiryDate && last4) {
      handleAddCreditCardFromURL({
        accountId: getAccountId(),
        userId: getUserName(),
        creditCard: {
          cardToken: token,
          cardExpiry: expiryDate,
          last4CC: last4,
          merchant: 'qabrain3',
        },
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.length) {
      this.setState({
        cardToken: nextProps.data[0].cardToken,
        cardExpiry: nextProps.data[0].cardExpiry,
        last4CC: nextProps.data[0].last4CC,
      });
    }
  }

  render() {
    const { cardToken, cardExpiry, last4CC } = this.state;
    const {
      t,
      topUpData,
      topUpTableColumns,
      onPay,
      onPayWithPlaceToPay,
      topUpAmount,
      onChangeTopUpAmount,
      minimumAmount,
      showMinAmountBox,
      processing,
      canTopUp,
      topUpBlockedMessage,
    } = this.props;

    const canPay = topUpAmount && Number(topUpAmount) > 0 && canTopUp;

    const domCVV = document.querySelector('.rccs__number');
    const domCardExpiry = document.querySelector('.rccs__expiry__valid');
    if (domCardExpiry) document.querySelector('.rccs__expiry__valid').textContent = 'Expiry';
    if (domCVV) document.querySelector('.rccs__number').textContent = `CVV: ${last4CC || ''}`;

    return (
      <div>
        <div className="cardtop">
          <br />
          <h4 className="card-title pl-4 pt-0">{t('label.currentPeriodBalance')}</h4>
          <div className="col-md-12 row">
            <div className="col-md-8">
              <div className="col-md-12">
                <DataTable columns={topUpTableColumns} data={topUpData || []} />
              </div>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="card-body top-up-card">
                  <div className="row mb-4">

                    {/* Conditionally renders the suggested amount based on the 3 rules */}
                    {showMinAmountBox && (
                      <div className="col-md-6">
                        <label className="font-weight-bold">{t('label.minimumTopUpAmount', 'Minimum Amount')}</label>
                        <div className="input-group">
                          <input type="text" className="form-control" value={minimumAmount} disabled />
                          <div className="input-group-append">
                            <span className="input-group-text">CRC</span>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Dynamically resize the amount box based on the boolean */}
                    <div className={showMinAmountBox ? "col-md-6" : "col-md-12"}>
                      <label className="font-weight-bold">{t('label.amount')}</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          value={topUpAmount || ''}
                          onChange={onChangeTopUpAmount}
                          placeholder="e.g. 1500"
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">CRC</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {!canTopUp && topUpBlockedMessage && (
                    <div className="alert alert-warning py-2 px-3 mb-3" role="alert">
                      {topUpBlockedMessage}
                    </div>
                  )}

                  <ul className="list-inline font-14 card-on-file d-flex">
                    <h4 className="card-title pl-0">{t('label.cardOnFile')}</h4>
                  </ul>
                  <Cards
                    cvc={last4CC || ''}
                    expiry={cardExpiry || ''}
                    focused=""
                    name={`Token: ${cardToken || ''}`}
                    number="asd"
                  />
                  <br />
                  <br />
                  <button
                    type="button"
                    disabled={!canPay || processing}
                    className="btn-submit btn-rounded waves-effect waves-light m-t-20 ml-0"
                    onClick={onPay}
                  >
                    {t('label.payNow')}
                  </button>
                  &nbsp;
                  {onPayWithPlaceToPay && (
                    <button
                      type="button"
                      disabled={!canPay || processing}
                      className="btn-submit btn-rounded waves-effect waves-light m-t-20 ml-0"
                      onClick={onPayWithPlaceToPay}
                      style={{ marginLeft: '8px' }}
                    >
                      {t('label.payWithPlaceToPay')}
                    </button>
                  )}
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TopUp.propTypes = {
  history: PropTypes.object,
  data: PropTypes.array,
  handleAddCreditCardFromURL: PropTypes.func,
  topUpData: PropTypes.array,
  topUpTableColumns: PropTypes.array,
  onPay: PropTypes.func,
  onPayWithPlaceToPay: PropTypes.func,
  topUpAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChangeTopUpAmount: PropTypes.func,
  minimumAmount: PropTypes.number,
  showMinAmountBox: PropTypes.bool,
  processing: PropTypes.bool,
  canTopUp: PropTypes.bool,
  topUpBlockedMessage: PropTypes.string,
};

export default withTranslation('common')(TopUp);